"use client"

import styled from "styled-components"

// Enhanced responsive container component
const Container = styled.div`
  width: 100%;
  max-width: ${({ $maxWidth, theme }) => $maxWidth || theme.grid.container.xl};
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.spacing.md};
  
  @media (max-width: ${({ theme }) => theme.breakpoints.xl}) {
    max-width: ${({ theme }) => theme.grid.container.lg};
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    max-width: ${({ theme }) => theme.grid.container.md};
    padding: 0 ${({ theme }) => theme.spacing.sm};
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    max-width: ${({ theme }) => theme.grid.container.sm};
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 0 ${({ theme }) => theme.spacing.xs};
  }
`

const ResponsiveContainer = ({ children, maxWidth, className, ...props }) => {
  return (
    <Container $maxWidth={maxWidth} className={className} {...props}>
      {children}
    </Container>
  )
}

export default ResponsiveContainer
